import React from "react";
import { ErrorPageSadEmojiIcon } from "../Icons/ErrorPageSadEmojiIcon";
import { ErrorPageWrapper } from "./ErrorPageWrapper";
import { useErrorIconSize } from "../Icons/ErrorIconSize";

/**
 * Shown when
 * - teacher has ended / stopped the call for all
 * - max call time is exceeded = call is expired
 * - after login when used got removed from the call previously
 * 
 * Don't use "usePcpLiveLessonContext" inside this component since it's not defined when the compnent is used from "pcp-live-lesson-call-expired-or-invalid-page" compnent.
 */
export const CallEndedOrNotAllowedPage = (): JSX.Element => {
    const iconSize = useErrorIconSize();
    return (
        <ErrorPageWrapper
            icon={<ErrorPageSadEmojiIcon size={iconSize}/>}
            content={<div>Der Unterricht ist <b>abgelaufen</b> oder Du bist <b>nicht berechtigt</b> daran teilzunehmen!</div>}
        />
    );
}